import { ToastProvider } from '../context/toast/ui/index';

export const withToastProvider = (component: () => React.ReactNode) => () =>
  <ToastProvider>{component()}</ToastProvider>;
